import { useCallback } from 'react';
import auditLogService from '../services/auditLog.service';

export const useAuditLog = (moduleName) => {
  const logAction = useCallback(async (action, details, additionalData = {}) => {
    try {
      await auditLogService.logAction(action, moduleName, details, additionalData);
    } catch (error) {
      console.error('Failed to log audit action:', error);
    }
  }, [moduleName]);

  const logCreate = useCallback(async (recordId, details) => {
    return auditLogService.logCreate(moduleName, recordId, details);
  }, [moduleName]);

  const logUpdate = useCallback(async (recordId, details) => {
    return auditLogService.logUpdate(moduleName, recordId, details);
  }, [moduleName]);

  const logDelete = useCallback(async (recordId, details) => {
    return auditLogService.logDelete(moduleName, recordId, details);
  }, [moduleName]);

  const logView = useCallback(async (recordId, details = '') => {
    return auditLogService.logView(moduleName, recordId, details);
  }, [moduleName]);

  const logExport = useCallback(async (details) => {
    return auditLogService.logExport(moduleName, details);
  }, [moduleName]);

  const logApprove = useCallback(async (recordId, details) => {
    return auditLogService.logApprove(moduleName, recordId, details);
  }, [moduleName]);

  const logReject = useCallback(async (recordId, details) => {
    return auditLogService.logReject(moduleName, recordId, details);
  }, [moduleName]);

  const logAssign = useCallback(async (resourceId, assigneeId, details) => {
    return auditLogService.logAssign(moduleName, resourceId, assigneeId, details);
  }, [moduleName]);

  const logConfiguration = useCallback(async (setting, oldValue, newValue) => {
    return auditLogService.logConfiguration(moduleName, setting, oldValue, newValue);
  }, [moduleName]);

  return {
    logAction,
    logCreate,
    logUpdate,
    logDelete,
    logView,
    logExport,
    logApprove,
    logReject,
    logAssign,
    logConfiguration
  };
};

export default useAuditLog;